import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import MvpApp from './MvpApp'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MvpApp />
  </StrictMode>,
)
